/** Объединение кассиров разных источников — служба Cashiers (RP-SEP1). */
const ROOT = '/api/cashiers/v1/groups'
export const CASHIER_GROUP_URLS = {
  directory: ROOT,
  candidates: `${ROOT}/candidates`,
  audit: (id: string) => `${ROOT}/${encodeURIComponent(id)}/audit`,
} as const
